module.exports = __webpack_public_path__ + "static/img/camera.ca7336f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/module-test-page/assets/camera.jpg
// module id = 3KYK
// module chunks = 1